import React from 'react'

export const IconArrow = ({ isOpen, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#222222"
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.3s ease',
      cursor: 'pointer',
    }}
    aria-label="Fechar"
    {...props}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
